import PropTypes from "prop-types";
import { CustomContainer } from "../../../DependencyHelper";
import { getValueLabel, getTotalDuration } from "../../../../../utils/helperServices";
import formStyles from "../CreditCheckDetails.module.scss";

const DebitDetailsInfo = ({ data, accountTypes }) => {
  

  return (
    <CustomContainer className={`${formStyles["form-details-container"]}`}>
      <CustomContainer className="row">
        <CustomContainer
          className={`${formStyles["pb-1"]} ${formStyles["pb-6"]} col-md-6 col-sm-12`}
        >
          <label>Bank:</label>
        </CustomContainer>
        <CustomContainer className={`${formStyles["pb-1"]} col-md-6 col-sm-12`}>
          <span>{data?.bank}</span>
        </CustomContainer>

        <CustomContainer
          className={`${formStyles["pb-1"]} ${formStyles["pb-6"]} col-md-6 col-sm-12`}
        >
          <label>Account type:</label>
        </CustomContainer>
        <CustomContainer className={`${formStyles["pb-1"]} col-md-6 col-sm-12`}>
          <span>{getValueLabel(data?.accountType, accountTypes)}</span>
        </CustomContainer>

        <CustomContainer
          className={`${formStyles["pb-1"]} ${formStyles["pb-6"]} col-md-6 col-sm-12`}
        >
          <label>Account number:</label>
        </CustomContainer>
        <CustomContainer className={`${formStyles["pb-1"]} col-md-6 col-sm-12`}>
          <span>{data?.accountNumber}</span>
        </CustomContainer>

        <CustomContainer
          className={`${formStyles["pb-1"]} ${formStyles["pb-6"]} col-md-6 col-sm-12`}
        >
          <label>Account holder name:</label>
        </CustomContainer>
        <CustomContainer className={`${formStyles["pb-1"]} col-md-6 col-sm-12`}>
          <span>{data?.initials + " " + data?.surname}</span>
        </CustomContainer>

        <CustomContainer
          className={`${formStyles["pb-1"]} ${formStyles["pb-6"]} col-md-6 col-sm-12`}
        >
          <label>How long have you had this account?</label>
        </CustomContainer>
        <CustomContainer className={`${formStyles["pb-1"]} col-md-6 col-sm-12`}>
          <span>{data?.ageOfAccountYears.toLowerCase()+", "+data?.ageOfAccountMonths.toLowerCase()}</span>
        </CustomContainer>

        <CustomContainer
          className={`${formStyles["pb-6"]} col-md-6 col-sm-12`}
        >
          <label>Preferred debit order date:</label>
        </CustomContainer>
        <CustomContainer className={`col-md-6 col-sm-12`}>
          <span>{data?.debitOrderDate}</span>
        </CustomContainer>
      </CustomContainer>
    </CustomContainer>
  );
};

DebitDetailsInfo.propTypes = {
  data: PropTypes.object,
  accountTypes: PropTypes.array,
};

DebitDetailsInfo.defaultProps = {
  data: {},
  accountTypes: [],
};

export default DebitDetailsInfo;
